// extracted by mini-css-extract-plugin
module.exports = {"loading":"CalculatingEquity_loading__3XN6P","text":"CalculatingEquity_text__2WGhU","rotation":"CalculatingEquity_rotation__3CBfc"};